module.exports = __webpack_public_path__ + "img/apply1.fc86de1d.png";